<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col class="text-center">
            <b-btn
              pill
              class="ml-2 mb-2"
              :variant="variant('all')"
              @click="setBubble('all')"
            >
              Tous
            </b-btn>
            <b-btn
              pill
              class="ml-2 mb-2"
              :variant="variant('positive')"
              @click="setBubble('positive')"
            >
              Parce que
            </b-btn>
            <b-btn
              pill
              class="ml-2 mb-2"
              :variant="variant('negative')"
              @click="setBubble('negative')"
            >
              Par contre
            </b-btn>
            <b-btn
              pill
              class="ml-2 mb-2"
              :variant="variant('neutral')"
              @click="setBubble('neutral')"
            >
              Donc
            </b-btn>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <graph-bubblecloud
          :height="500"
          :widht="0"
          :padding-top="5"
          :padding-bottom="0"
          :padding-left="0"
          :padding-right="0"
          :values="bubbleValue"
          :colors="colors"
          :styles="bubblecloud.styles"
          :render-interval="200"
          :key="bubbleAvg"
        >
        </graph-bubblecloud>
      </b-col>
      <b-col cols="12">
        <b-card bg-variant="light" class="rounded-lg">
          <div class=" d-flex justify-content-between ">
            <div>
              <label class="text-muted rotate mr-4">Mots clés détectés </label>
              <b-button
                variant="link"
                class="float-right mr-2 px-1"
                v-b-modal.modal-1
              >
                <b-icon
                  font-scale="1.1"
                  icon="question-circle-fill"
                  variant="secondary"
                ></b-icon>
              </b-button>
            </div>
            <div>
              <b-btn
                pill
                class="ml-2 mb-2"
                variant="outline-secondary"
                @click="setTable"
              >
                <span v-if="tableSelect == 'keyword'">
                  Sources
                </span>
                <span v-else>Mot clé</span>
              </b-btn>
            </div>
          </div>
          <b-table
            ref="selectableTable"
            show-empty
            stacked="md"
            :items="items"
            outlined
            bordered
            :busy="isBusy"
            hover
            small
            :fields="fields"
            :key="tableSelect"
            empty-text="Aucun mots clés détectés"
          >
            <template v-slot:cell(keyword)="data">
              <b-link @click="commentSearch(data.value.key)">
                {{ data.value.key + ` (${data.value.total})` }}
              </b-link>
              <b-button size="sm" variant="none" pill>
                <b-icon
                  icon="x-circle"
                  @click="onDeleteWord(data.value.key)"
                ></b-icon>
              </b-button>
            </template>
            <template v-slot:cell(url)="data">
              <b-link :href="data.value.key" target="_blank">
                {{ data.value.key + ` (${data.value.total})` }}
              </b-link>
            </template>
          </b-table>
          <!----------- Search -------------->
          <div class="float-right" v-if="tableSelect == 'keyword'">
            <b-form inline>
              <label for="" class="mr-2">Ajouter un mot-clé</label>
              <b-input class="mb-2 mr-sm-2 mb-sm-0" v-model="keyword"></b-input>

              <b-button variant="primary" pill @click="onSearchWord(keyword)"
                ><BIconPlus></BIconPlus
              ></b-button>
            </b-form>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12">
        <section>
          <div v-for="comment in comments" :key="comment.id">
            <p>
              <span class="d-block">
                {{ comment.user.name }} {{ comment.user.last_name }}
              </span>
              <small class="text-muted">{{
                comment.created_at | formatDateTime
              }}</small>
            </p>
            <p>
              <span class="text-success mr-1" v-if="comment.type == 1">
                Parce que
              </span>
              <span class="text-danger mr-1" v-if="comment.type == 2">
                Par contre
              </span>
              <span class="text-primary mr-1" v-if="comment.type == 3">
                Donc
              </span>
              {{ comment.comment }}
            </p>
            <div v-if="comment.messages.length != 0">
              <b-row>
                <b-col sm="1" md="1" lg="1" class="text-right">
                  <b-icon
                    class="mr-1"
                    icon="envelope"
                    variant="secondary"
                  ></b-icon>
                </b-col>
                <b-col>
                  <div v-for="message in comment.messages" :key="message.id">
                    <span class="d-block">
                      {{ message.user.name }} {{ message.user.last_name }}
                    </span>
                    <span class="text-muted">{{ message.created_date }}</span>
                    <p>
                      {{ message.message }}
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>
            <hr />
          </div>
        </section>
      </b-col>
    </b-row>
    <b-modal id="modal-1" title="Comment dlibr trouve les mots clés?" size="lg">
      <b-container>
        <p class="my-4">
          Le système Dlibr trouve les mots automatiquement qui sont répétés plus
          de 5 fois et qui sont de 3 lettres et plus. De plus, sa recherche
          élimine les déterminants.
        </p>
        <p>
          Les mots que vous ajoutés seront exemptes de ces règles.
        </p>
      </b-container>
      <template v-slot:modal-footer="{ cancel }">
        <div class="w-100">
          <b-button
            variant="primary"
            pill
            class="float-right"
            @click="cancel()"
          >
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
/**
 * @file       Deliberation keyword graph component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "keywordGraph",

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      keyword: null,
      comments: Array,
      tableSelect: "keyword",
      bubbleSelect: "all",
      bubblecloud: {
        styles: {
          titleFontSize: 15,
          titleFontWeight: "bold"
        }
      },
      fields: [
        {
          key: "keyword",
          label: "Mot (nombre de fois trouvé)",
          class: "text-center"
        },
        {
          key: "positive",
          label: "Pour",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "negative",
          label: "Par contre",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "neutral",
          label: "Donc",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        }
      ]
    };
  },

  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("deliberations/getDlibr", {
        params: { teacher: to.params.teacher, url: to.params.url }
      })
      .then(({ data }) =>
        store
          .dispatch("deliberations/getKeywordDlibr", {
            params: { deliberation: data.data.find(d => d).id }
          })
          .then(() => next())
      )
      .catch(() => {
        next(vm => {
          vm.$root.$bvToast.toast(
            "Aucune délibération trouvée pour cette URL",
            {
              title: "Erreur",
              variant: "danger"
            }
          );
          vm.$router.push({ name: "home" });
        });
      });
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      keywordDlibr: state => state.deliberations.keywordDlibr,
      dlibr: state => state.deliberations.dlibr
    }),

    /**
     * Check if the status of keyword deliberations is busy.
     *
     * @return     {bool}  Busy or not.
     */
    isBusy() {
      return this.keywordDlibr.status === "fetching";
    },
    items: function() {
      let items = [];
      let table;
      if (this.tableSelect == "keyword") {
        table = this.keywordDlibr.data.data.keywords;
      } else {
        table = this.keywordDlibr.data.data.sources;
      }
      table = [...table];
      table.sort((a, b) =>
        a.total > b.total ? -1 : b.total > a.total ? 1 : 0
      );
      table.forEach(row => {
        if (this.tableSelect == "keyword") {
          items.push({
            keyword: { key: row.keyword.keyword, total: row.total },
            positive: row.total_positive,
            negative: row.total_negative,
            neutral: row.total_neutral
          });
        } else {
          items.push({
            url: { key: row.url, total: row.total },
            positive: row.total_positive,
            negative: row.total_negative,
            neutral: row.total_neutral
          });
        }
      });
      return items.slice(0, 10);
    },
    bubbleValue: function() {
      let items = [];
      let table = [];
      //check source data
      table = this.keywordDlibr.data.data.keywords;
      //reactivityless data
      table = [...table];
      //check bubbles type
      if (this.bubbleSelect == "all") {
        table.sort((a, b) =>
          a.total > b.total ? -1 : b.total > a.total ? 1 : 0
        );
        //assign data to array items
        table.forEach(row => {
          if (row.total != 0) {
            items.push([row.keyword.keyword, row.total, this.bubbleSelect]);
          }
        });
      } else if (this.bubbleSelect == "positive") {
        table.sort((a, b) =>
          a.total_positive > b.total_positive
            ? -1
            : b.total_positive > a.total_positive
            ? 1
            : 0
        );
        table.forEach(row => {
          if (row.total_positive != 0) {
            items.push([
              row.keyword.keyword,
              row.total_positive,
              this.bubbleSelect
            ]);
          }
        });
      } else if (this.bubbleSelect == "negative") {
        table.sort((a, b) =>
          a.total_negative > b.total_negative
            ? -1
            : b.total_negative > a.total_negative
            ? 1
            : 0
        );
        table.forEach(row => {
          if (row.total_negative != 0) {
            items.push([
              row.keyword.keyword,
              row.total_negative,
              this.bubbleSelect
            ]);
          }
        });
      } else if (this.bubbleSelect == "neutral") {
        table.sort((a, b) =>
          a.total_neutral > b.total_neutral
            ? -1
            : b.total_neutral > a.total_neutral
            ? 1
            : 0
        );
        table.forEach(row => {
          if (row.total_neutral != 0) {
            items.push([
              row.keyword.keyword,
              row.total_neutral,
              this.bubbleSelect
            ]);
          }
        });
      }
      return items.slice(0, 10);
    },
    bubbleAvg: function() {
      return (
        this.bubbleValue.reduce((s, v) => s + v[1], 0) /
        this.bubbleValue.length /
        3
      ).toFixed(0);
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Delete keyword.
     *
     * @param     {Object}   data   The keyword.
     */
    onDeleteWord(data) {
      store.commit("deliberations/deleteKeywordDlibr", data);
    },

    /**
     * Search keyword.
     *
     * @param     {Object}   keyword   The keyword.
     */
    onSearchWord(keyword) {
      store
        .dispatch("deliberations/searchKeywordDlibr", {
          params: {
            deliberation: this.dlibr.data.data.find(d => d).id,
            keyword
          }
        })
        .then()
        .catch(() => {
          this.$root.$bvToast.toast(
            `Aucun résultat de recherche n'a été trouvé`,
            {
              title: "Erreur",
              variant: "danger"
            }
          );
        });
    },

    /**
     * Set table.
     */
    setTable: function() {
      this.fields.forEach((field, i) => {
        if (field.label == "Mot (nombre de fois trouvé)") {
          this.fields[i].key = field.key == "keyword" ? "url" : "keyword";
        }
      });
      this.tableSelect = this.tableSelect == "keyword" ? "source" : "keyword";
    },

    /**
     * Set bubble.
     *
     * @param     {Object}   type   The type.
     */
    setBubble: function(type) {
      this.bubbleSelect = type;
    },

    /**
     * Get variant.
     *
     * @param     {Object}   type   The type.
     *
     * @return    {String}   The label.
     */
    variant: function(type) {
      if (type == this.bubbleSelect) {
        if (this.bubbleSelect == "all") {
          return "primary";
        } else if (this.bubbleSelect == "positive") {
          return "success";
        } else if (this.bubbleSelect == "negative") {
          return "danger";
        } else if (this.bubbleSelect == "neutral") {
          return "purple";
        }
      }
      return "secondary";
    },

    /**
     * Comment search.
     *
     * @param     {Object}   key   The search key.
     */
    commentSearch(key) {
      store.commit("comments/setCommentsFilters", {
        reset: true,
        fields: {
          search: key,
          deliberation: this.dlibr.data.data.find(u => u == u).id,
          resourcesPerPage: 20
        }
      });
      store.dispatch("comments/getComments").then(response => {
        this.comments = response.data.data;
      });
    },

    /**
     * Get color.
     *
     * @param     {Object}   data   The data.
     *
     * @return    {String}   The hex color code.
     */
    colors: function(data) {
      if (data[2] == "all") {
        if (data[1] <= this.bubbleAvg * 2) {
          return "#33336655";
        } else if (data[1] <= this.bubbleAvg * 3) {
          return "#33336695";
        }
        return "#333366";
      } else if (data[2] == "positive") {
        if (data[1] <= this.bubbleAvg * 2) {
          return "#00996655";
        } else if (data[1] <= this.bubbleAvg * 3) {
          return "#00996695";
        }
        return "#009966";
      } else if (data[2] == "negative") {
        if (data[1] <= this.bubbleAvg * 2) {
          return "#FF666655";
        } else if (data[1] <= this.bubbleAvg * 3) {
          return "#FF666695";
        }
        return "#FF6666";
      } else if (data[2] == "neutral") {
        if (data[1] <= this.bubbleAvg * 2) {
          return "#6666CC55";
        } else if (data[1] <= this.bubbleAvg * 3) {
          return "#6666CC95";
        }
        return "#6666CC";
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
